// import { getTotal } from "../utils/gameHelpers";
import {
  AchievementType,
  EquationType,
  OperatorType,
} from "../types/generalTypes";
import { OPERATORS } from "./constants";

// const operators = ["+", "-", "×", "÷"];

const achievements: AchievementType[] = [];
// Set up Achievement list
// achievements.push({
//   name: "Solved",
//   info: "Reach the target",
//   check: (eq, target) => getTotal(eq) === target,
// });
achievements.push({
  id: "odd",
  // name: "Odd",
  // info: "Solve using an odd number of tiles.",
  check: (eq) => ((eq.length + 1) / 2) % 2 === 1,
});
achievements.push({
  id: "even",
  // name: "Even",
  // info: "Solve using an even number of tiles.",
  check: (eq) => ((eq.length + 1) / 2) % 2 === 0,
});
achievements.push({
  id: "three",
  // name: "Three",
  // info: "Solve using a maximum of 3 tiles.",
  check: (eq) => (eq.length + 1) / 2 <= 3,
});
achievements.push({
  id: "extremes",
  // name: "Extremes",
  // info: "Use the smallest and largest number.",
  check: (eq, target, grid) =>
    (eq.filter(Number) as number[]).filter(
      (a) => a === Math.min(...grid) || a === Math.max(...grid)
    ).length === 2,
});
achievements.push({
  id: "divide",
  // name: "Divide & Conquer",
  // info: "Solve with at least one use of division.",
  check: (eq) => eq.indexOf("÷") >= 0,
});
achievements.push({
  id: "operators",
  // name: "Smooth Operators",
  // info: "Solve using all of the operators at least once.",
  check: (eq) => OPERATORS.every((o) => eq.indexOf(o) >= 0),
});
achievements.push({
  id: "positive",
  // name: "Stay Positive",
  // info: "Solve without using subtraction.",
  check: (eq) => eq.indexOf("-") < 0,
});
achievements.push({
  id: "ten",
  // name: "10+",
  // info: "Solve using only tiles of 10 and over.",
  check: (eq) =>
    (eq.filter(Number) as number[]).filter((a) => a < 10).length === 0,
});
// achievements.push({
//   name: "Five ways",
//   info: "Reach the target in at least 5 unique ways.",
//   check: (eq, target, grid, solutions) => solutions.length >= 5,
// });
// TODO: No touching

export type AppStateType = {
  showHowTo?: boolean;
  showMobileAchievements: boolean;
  showMobileSolutions: boolean;
  gridWidth: number;
  gridHeight: number;
  screenWidth: number;
  screenHeight: number;
  tabIndex: number;
  titleScreen: boolean;
  newGridMenu: null;
  equationDiv: HTMLDivElement | "";
  reviewShown: number;
};
export type GameStateType = {
  target: number;
  grid: number[];
  eq?: EquationType;
  eqPos?: number;
  solutions: EquationType[];
  cols?: number;
  rows?: number;
  achievementDiff?: AchievementType[];
  solutionNew?: boolean;
};
export type StateType = {
  app: AppStateType;
  game: GameStateType;
};

export type LanguageType = {
  langCode: string;
  name: string;
  flagEmoji: string;
};

export const languages: LanguageType[] = [
  {
    langCode: "en",
    name: "English",
    flagEmoji: "🇬🇧",
  },
  {
    langCode: "es",
    name: "Español",
    flagEmoji: "🇪🇸",
  },
  {
    langCode: "fr",
    name: "Français",
    flagEmoji: "🇫🇷",
  },
  {
    langCode: "de",
    name: "Deutsch",
    flagEmoji: "🇩🇪",
  },
  {
    langCode: "it",
    name: "Italiano",
    flagEmoji: "🇮🇹",
  },
  {
    langCode: "pt",
    name: "Português",
    flagEmoji: "🇵🇹",
  },
  {
    langCode: "nl",
    name: "Nederlands",
    flagEmoji: "🇳🇱",
  },
  {
    langCode: "ko",
    name: "한국어",
    flagEmoji: "🇰🇷",
  },
  {
    // Chinese (Simplified) = zh
    langCode: "zh",
    name: "中文",
    flagEmoji: "🇨🇳",
  },
  {
    // Chinese (Traditional) = zh-TW
    langCode: "zh-TW",
    name: "中文(繁體)",
    flagEmoji: "🇹🇼",
  },
  {
    langCode: "hi",
    name: "हिन्दी",
    flagEmoji: "🇮🇳",
  },
  {
    langCode: "ja",
    name: "日本語",
    flagEmoji: "🇯🇵",
  },
  // {
  //   langCode: "pl",
  //   name: "Polski",
  // },
  // {
  //   langCode: "ru",
  //   name: "Русский",
  // },
  // {
  //   langCode: "tr",
  //   name: "Türkçe",
  // },
  // {
  //   langCode: "ar",
  //   name: "العربية",
  // },
  // {
  //   langCode: "bn",
  //   name: "বাংলা",
  // },
  // {
  //   langCode: "ms",
  //   name: "Bahasa Melayu",
  // },
  // {
  //   langCode: "fil",
  //   name: "Filipino",
  // },
  // {
  //   langCode: "vi",
  //   name: "Tiếng Việt",
  // },
  // {
  //   langCode: "th",
  //   name: "ภาษาไทย",
  // },
  // {
  //   langCode: "id",
  //   name: "Bahasa Indonesia",
  // },
  // {
  //   langCode: "he",
  //   name: "עברית",
  // },
  // {
  //   langCode: "el",
  //   name: "Ελληνικά",
  // },
  // {
  //   langCode: "cs",
  //   name: "Čeština",
  // },
  // {
  //   langCode: "hu",
  //   name: "Magyar",
  // },
  // {
  //   langCode: "ro",
  //   name: "Română",
  // },
  // {
  //   langCode: "sv",
  //   name: "Svenska",
  // },
  // {
  //   langCode: "da",
  //   name: "Dansk",
  // },
];

const config: {
  tileLow: number;
  tileMax: number;
  targetMin: number;
  targetMax: number;
  gridSizes: string[];
  achievements: AchievementType[];
  operators: OperatorType[];
  padding: number;
  desktop: number;
  initialState: StateType;
} = {
  tileLow: 1,
  tileMax: 99,
  targetMin: 100,
  targetMax: 999,
  gridSizes: ["5x4", "4x4", "4x3", "3x3"],
  achievements,
  operators: OPERATORS,
  padding: 4,
  desktop: 768,
  initialState: {
    app: {
      showHowTo: undefined,
      showMobileAchievements: false,
      showMobileSolutions: false,
      gridWidth: 300,
      gridHeight: 300,
      screenWidth: 0,
      screenHeight: 0,
      tabIndex: 0,
      titleScreen: false,
      newGridMenu: null,
      equationDiv: "",
      reviewShown: 0,
    },
    game: {
      target: 0,
      grid: [],
      eq: [],
      eqPos: 0,
      solutions: [],
      cols: 4,
      rows: 3,
      achievementDiff: [],
    },
  },
};

export default config;
